// RingPrestige Interactivity & Search Engine Script - Fixed for Shopify Integration

// Curated collection of luxury vanity numbers
const premiumNumbers = [
  {
    number: "(855) 777-7777",
    price: "$5,000",
    tier: "gold",
    type: "easy",
    category: "Lucky Sevens - Ultra Premium Repeating Pattern"
  },
  {
    number: "(800) LAW-FIRM",
    price: "$12,500",
    tier: "vip",
    type: "vanity",
    category: "High-Authority Legal Brand Indicator"
  },
  {
    number: "(888) 888-0000",
    price: "$8,500",
    tier: "vip",
    type: "vip",
    category: "Prestigious Corporate Block Pattern"
  },
  {
    number: "(855) TAX-PREP",
    price: "$3,200",
    tier: "silver",
    type: "vanity",
    category: "Seasonal Finance Category Leader"
  },
  {
    number: "(877) 877-8777",
    price: "$4,500",
    tier: "gold",
    type: "easy",
    category: "Double Repeating Triple Accent Pattern"
  },
  {
    number: "(888) 999-9999",
    price: "$25,000",
    tier: "vip",
    type: "vip",
    category: "The Ultimate Status Symbol Number"
  },
  {
    number: "(800) 222-3333",
    price: "$2,800",
    tier: "silver",
    type: "easy",
    category: "Easy-Recall Alternating Double Blocks"
  },
  {
    number: "(866) VIP-LINE",
    price: "$6,200",
    tier: "gold",
    type: "vanity",
    category: "Exclusive Concierge & Support Accent Word"
  },
  {
    number: "(855) CAR-LOAN",
    price: "$4,000",
    tier: "silver",
    type: "vanity",
    category: "Perfect for Finance & Dealerships"
  }
];

// Export database globally
window.premiumNumbers = premiumNumbers;

// DOM Elements
const numbersGrid = document.getElementById('numbersGrid');
const searchInput = document.getElementById('searchInput');
const searchBtn = document.getElementById('searchBtn');
const tabButtons = document.querySelectorAll('.tab-btn');
const mobileMenuToggle = document.querySelector('.mobile-nav-toggle');
const navMenu = document.querySelector('.nav-menu');
const inquiryForm = document.getElementById('inquiryForm');
const inquiryModal = document.getElementById('inquiryModal');
const modalCloseBtn = document.getElementById('modalCloseBtn');
const modalOkBtn = document.getElementById('modalOkBtn');
const modalMessage = document.getElementById('modalMessage');
const viewAllBtn = document.getElementById('viewAllBtn');

// Active filter states
let activeFilter = 'all';
let searchQuery = '';
let showAllInventory = false;

// Initial Setup
document.addEventListener('DOMContentLoaded', () => {
  renderNumbers();
  setupNavigation();
  setupFilters();
  setupSearch();
  setupForm();
  setupModal();
});

// Render function for numbers grid
function renderNumbers() {
  if (!numbersGrid) return;
  
  numbersGrid.innerHTML = '';
  
  let filtered = premiumNumbers.filter(item => {
    if (activeFilter !== 'all') {
      if (activeFilter === 'vanity' && item.type !== 'vanity') return false;
      if (activeFilter === 'easy' && item.type !== 'easy') return false;
      if (activeFilter === 'vip' && item.tier !== 'vip') return false;
    }
    
    if (searchQuery.trim() !== '') {
      const q = searchQuery.toLowerCase();
      const numMatch = item.number.replace(/\D/g, '').includes(q.replace(/\D/g, ''));
      const textMatch = item.number.toLowerCase().includes(q);
      const catMatch = item.category.toLowerCase().includes(q);
      const tierMatch = item.tier.toLowerCase().includes(q);
      
      if (!numMatch && !textMatch && !catMatch && !tierMatch) return false;
    }
    
    return true;
  });

  const displayLimit = showAllInventory ? filtered.length : 6;
  const itemsToRender = filtered.slice(0, displayLimit);

  if (itemsToRender.length === 0) {
    numbersGrid.innerHTML = `
      <div class="no-results">
        <i class="fa-solid fa-face-frown"></i>
        <h3>No matching prestige numbers found</h3>
        <p>Try searching for different digits, vanity words, or browse other categories.</p>
      </div>
    `;
    return;
  }

  itemsToRender.forEach(item => {
    const card = document.createElement('div');
    card.className = `number-card tier-${item.tier}`;
    
    let badgeClass = 'badge-silver';
    if (item.tier === 'gold') badgeClass = 'badge-gold';
    if (item.tier === 'vip') badgeClass = 'badge-vip';
    
    const ctaBtnClass = item.tier === 'vip' ? 'btn-filled' : 'btn-outline';

    card.innerHTML = `
      <div class="card-top">
        <span class="number-badge ${badgeClass}">${item.tier}</span>
        <span class="number-price">${item.price}</span>
      </div>
      <div class="card-phone">${item.number}</div>
      <div class="card-category">${item.category}</div>
      <button class="btn ${ctaBtnClass} card-cta" data-number="${item.number}">Inquire Now</button>
    `;
    
    numbersGrid.appendChild(card);
  });

  // ربط الأزرار بالبوب أب مباشرة لمنع الانهيار
  document.querySelectorAll('.card-cta').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const number = e.target.getAttribute('data-number');
      handleInquiryClick(number);
    });
  });
}

// Navigation & Hamburger Menu
function setupNavigation() {
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', () => {
      navMenu.classList.toggle('active');
      const isOpened = navMenu.classList.contains('active');
      mobileMenuToggle.innerHTML = isOpened ? '<i class="fa-solid fa-xmark"></i>' : '<i class="fa-solid fa-bars"></i>';
    });
  }

  document.querySelectorAll('.nav-link').forEach(link => {
    link.addEventListener('click', () => {
      if (navMenu) navMenu.classList.remove('active');
      if (mobileMenuToggle) mobileMenuToggle.innerHTML = '<i class="fa-solid fa-bars"></i>';
    });
  });

  const header = document.querySelector('.header');
  window.addEventListener('scroll', () => {
    if (!header) return;
    if (window.scrollY > 40) {
      header.style.background = 'rgba(2, 3, 5, 0.95)';
      header.style.height = '80px';
      header.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.8)';
    } else {
      header.style.background = 'rgba(3, 5, 8, 0.75)';
      header.style.height = '90px';
      header.style.boxShadow = 'none';
    }
  });
}

// Tab filtering system
function setupFilters() {
  tabButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      tabButtons.forEach(b => b.classList.remove('active'));
      e.target.classList.add('active');
      activeFilter = e.target.getAttribute('data-filter');
      renderNumbers();
    });
  });

  document.querySelectorAll('.tier-link').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetTier = e.currentTarget.getAttribute('data-tier');
      
      tabButtons.forEach(btn => {
        if (btn.getAttribute('data-filter') === targetTier) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });

      activeFilter = targetTier;
      renderNumbers();

      const searchSection = document.getElementById('search');
      if (searchSection) searchSection.scrollIntoView({ behavior: 'smooth' });
    });
  });
}

// Search Inputs
function setupSearch() {
  if (searchBtn) {
    searchBtn.addEventListener('click', () => {
      searchQuery = searchInput.value;
      renderNumbers();
    });
  }

  if (searchInput) {
    searchInput.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') {
        searchQuery = searchInput.value;
        renderNumbers();
      }
    });
  }

  // تفعيل زر View All مع منع إعادة تحميل الصفحة (e.preventDefault)
  if (viewAllBtn) {
    viewAllBtn.addEventListener('click', (e) => {
      e.preventDefault(); // السطر السحري الذي يمنع الـ Reload نهائياً
      e.stopPropagation();
      
      showAllInventory = !showAllInventory;
      viewAllBtn.textContent = showAllInventory ? "Collapse Inventory" : "View Full Inventory";
      renderNumbers();
    });
  }
}

// الإصلاح البرمجي الذهبي: فتح البوب أب في نفس الصفحة ومنع الانتقال المكسور
function handleInquiryClick(phoneNumber) {
  // تشغيل الـ Modal الزجاجية الفخمة الموجودة في الـ theme.liquid تلقائياً
  const inquiryModal = document.getElementById('inquiryModal');
  const modalMessage = document.getElementById('modalMessage');
  
  if (inquiryModal && modalMessage) {
    modalMessage.innerHTML = `You are inquiring about the premium number: <strong style="color:#D4AF37; font-size:20px; display:block; margin:10px 0;">${phoneNumber}</strong> Our concierge team will lock this digits asset and contact you within 15 minutes.`;
    inquiryModal.style.display = 'flex';
    inquiryModal.classList.add('active');
    
    // سحب الفوكس أوتوماتيكياً لنموذج البيانات السفلي لتسهيل الإرسال للعميل
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      // حقن الرقم تلقائياً في خانة التفاصيل بداخل فورم التواصل الأساسية لضمان وصولها للإيميل
      const messageField = document.getElementById('message');
      if (messageField) messageField.value = `I am interested in acquiring the premium vanity number: ${phoneNumber}. Please send me the secure escrow transaction details.`;
    }
  }
}

// Form Submission handling
function setupForm() {
  if (!inquiryForm) return;

  inquiryForm.addEventListener('submit', (e) => {
    e.preventDefault();
    
    const name = document.getElementById('name').value;
    const email = document.getElementById('email').value;
    const phone = document.getElementById('phone').value;

    if (modalMessage) {
      modalMessage.innerHTML = `Thank you, <strong>${name}</strong>. Your inquiry for Vitmoor numbers has been sent directly to our executive team. <br><br>We will reach out to you via <strong>${email}</strong> or <strong>${phone}</strong> within 15 minutes.`;
    }
    
    if (inquiryModal) {
      inquiryModal.style.display = 'flex';
      inquiryModal.classList.add('active');
    }
    
    inquiryForm.reset();
  });
}
// Modal handling with dynamic scroll redirection
function setupModal() {
  if (!inquiryModal) return;

  const closeModalAndScroll = () => {
    inquiryModal.classList.remove('active');
    inquiryModal.style.display = 'none';
    
    // حركة سكول انسيابية تأخذ العميل لفورم إدخال الاسم والإيميل مباشرة
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // ربط زر Confirm وزر الإغلاق بالحركة الذكية
  if (modalCloseBtn) modalCloseBtn.addEventListener('click', () => { inquiryModal.style.display = 'none'; });
  if (modalOkBtn) modalOkBtn.addEventListener('click', closeModalAndScroll);
  
  inquiryModal.addEventListener('click', (e) => {
    if (e.target === inquiryModal) {
      inquiryModal.style.display = 'none';
    }
  });
}